import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FileText,
  Edit,
  BarChart3,
  ArrowRight,
  Settings,
  DownloadIcon,
} from "lucide-react";
import logo from "./MElogo.jpeg";
import Header from "../components/header";

const Logo = () => (
  <img src={logo} alt="Blast Stope Recovery" className="h-10 w-10 rounded" />
);

const FeatureCard = ({ icon: Icon, title, description, color, onClick }) => (
  <button
    onClick={onClick}
    className="group relative flex flex-col h-full bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden"
  >
    <div className="absolute top-0 left-0 right-0 h-1 bg-cyan-500" />

    <div className="p-8 flex flex-col h-full">
      <div className="w-14 h-14 rounded-lg bg-cyan-50 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
        <Icon className="w-7 h-7 text-cyan-600" />
      </div>

      <div className="text-left flex-grow">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 mb-6">{description}</p>
      </div>

      <div className="flex items-center text-sm font-medium group-hover:translate-x-1 transition-transform duration-300 mt-auto">
        <span className="text-cyan-600">Get Started</span>
        <ArrowRight className="w-4 h-4 ml-1 text-cyan-600" />
      </div>
    </div>
  </button>
);

const HomePage = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: FileText,
      title: "Create New Analysis",
      description:
        "Upload and analyze new stope data with advanced visualization tools.",
      path: "upload",
    },
    {
      icon: Edit,
      title: "Modify Analysis",
      description:
        "Review and edit existing stope analyses with precise controls.",
      path: "search",
    },
    {
      icon: BarChart3,
      title: "Analysis Reports",
      description:
        "Generate comprehensive reports and insights from your data.",
      path: "report",
    },
    {
      icon: DownloadIcon,
      title: "Download Scanned Stope Files",
      description: "Access and download your existing stope files.",
      path: "files",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header>
        <Header />
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4">
            Welcome to Stope Recovery
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select an option below to begin analyzing and optimizing your stope
            recovery operations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              {...feature}
              onClick={() => navigate(`/${feature.path}`)}
            />
          ))}
        </div>
      </main>
    </div>
  );
};

export default HomePage;
